<template>
    <div class="content-grid content-grid--subpage">
        <Breadcrumbs :title="t(`routes.coproperty.children.${!isEditMode ? 'add' : 'edit'}Document.name`)"/>
        <BackLinkTitle :title="t(`routes.coproperty.children.${!isEditMode ? 'add' : 'edit'}Document.name`)"/>

        <Card>
            <DocumentForm :id="documentId"/>
        </Card>
    </div>
</template>

<script lang="ts" setup>
import Card from "@/components/layout/Card.vue";
import BackLinkTitle from "@/components/layout/BackLinkTitle.vue";
import Breadcrumbs from "@/components/layout/Breadcrumbs.vue";
import {useI18n} from "vue3-i18n";
import {computed} from "vue";
import {Guid} from "@/types";
import {useRoute} from "vue-router";
import DocumentForm from "@/components/forms/DocumentForm.vue";

const {t} = useI18n()

const route = useRoute()

const documentId = computed(() => {
    let id = ""
    if (typeof route.params.id === 'string')
        id = route.params.id

    return id
})
const isEditMode = computed(() => Guid.isValid(documentId.value));
</script>
